import { computed } from 'vue'
import { useAuthSession } from '@/modules/auth/public'
import { useChatStore } from './store/chat'

export { chatRoutes, createChatRoutes } from './routes'
export type { ChatParticipant, ChatSummary, Message, MessageAttachment } from './model/types'

/**
 * Узкий фасад для внешних модулей (OrderView и др.): загрузка/создание чата
 * поддержки, сообщения и identity текущего пользователя без reach-in в store.
 */
export function useChatSupport() {
  const chatStore = useChatStore()
  const { user } = useAuthSession()

  return {
    chats: computed(() => chatStore.chats),
    currentUser: computed(() => ({
      id: user.value?.id ?? 0,
      name: user.value?.name ?? '',
    })),
    currentUserId: computed(() => user.value?.id ?? 0),
    loadChats: (params?: Parameters<typeof chatStore.loadChats>[0]) => chatStore.loadChats(params),
    createChat: (data: Parameters<typeof chatStore.createChat>[0]) => chatStore.createChat(data),
    getChatById: (chatId: number) => chatStore.getChatById(chatId),
    getMessagesByChatId: (chatId: number) => chatStore.getMessagesByChatId(chatId),
    loadMessages: (chatId: number, page?: number, limit?: number) =>
      chatStore.loadMessages(chatId, page, limit),
    sendMessage: (payload: Parameters<typeof chatStore.sendMessage>[0]) =>
      chatStore.sendMessage(payload),
    clearMessages: (chatId: number) => chatStore.clearMessages(chatId),
  }
}
